import React, {useState} from 'react';
import {connect} from "react-redux";

import {Dispatch} from "@Redux/type";
import {AppState} from "@Redux/store";
import { ButtonGroup, Button, Row, Col } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { defaultMessages } from '@I18n/default';
import Repeater from '@Utils/Repeater';

const ArmyListFileExport: React.FC<ArmyListFileExportProps> = ({ armyListId }) => {

  const [verbosity, setVerbosity] = useState('full')
  const [magic, setMagic] = useState('magics')
  const [format, setFormat] = useState('html')
  const [qrcode, setQrcode] = useState('qrcode')

  const verbosities = [
    {name: 'Full', value: 'full'},
    {name: 'Lite', value: 'lite'}
  ];
  const magics = [
    {name: 'With magics', value: 'magics'},
    {name: 'no magic', value: 'nomagics'}
  ];
  const formats = [
    {name: 'HTML', value: 'html'},
    {name: 'PDF', value: 'pdf'}
  ];
  const qrcodes = [
    {name: 'With', value: 'qrcode'},
    {name: 'Without', value: 'noqrcode'}
  ];

  const exportHtml = `/${document.documentElement.lang}/builder/army_lists/${armyListId}/export-${verbosity}-${magic}-page-${qrcode}.${format}`;

  return <Row className="justify-content-center">
    <Col xs={12} md={5}>
      <div>
        <p className="text-center"><FormattedMessage {...defaultMessages.armyListExportVerbosity} />:</p>
        <div className="btn-group btn-group-full d-flex" role="group"
             aria-label="Button group with nested verbosity">
          <ButtonGroup className="mb-2">
            <Repeater data={verbosities} indexPrefix="verbosity">
              {
                (radio: any) => (
                  <Button
                    value={radio.value}
                    color={radio.value === verbosity ? 'success' : 'secondary'}
                    onClick={(e) => setVerbosity(e.currentTarget.value)}
                  >
                    {radio.name}
                  </Button>
                )
              }
            </Repeater>
          </ButtonGroup>
        </div>
      </div>
      <div>
        <p className="text-center"><FormattedMessage {...defaultMessages.armyListExportIncludeMagics} /></p>
        <div className="btn-group btn-group-full d-flex" role="group"
             aria-label="Button group with nested verbosity">
          <ButtonGroup className="mb-2">
            <Repeater data={magics} indexPrefix="magic">
              {
                (radio: any) => (
                  <Button
                    value={radio.value}
                    color={radio.value === magic ? 'success' : 'secondary'}
                    onClick={(e) => setMagic(e.currentTarget.value)}
                  >
                    {radio.name}
                  </Button>
                )
              }
            </Repeater>
          </ButtonGroup>
        </div>
      </div>
      <div>
        <p className="text-center"><FormattedMessage {...defaultMessages.armyListExportIncludeQrcodes} /></p>
        <div className="btn-group btn-group-full d-flex" role="group"
             aria-label="Button group with nested verbosity">
          <ButtonGroup className="mb-2">
            <Repeater data={qrcodes} indexPrefix="qrcode">
              {
                (radio: any) => (
                  <Button
                    value={radio.value}
                    color={radio.value === qrcode ? 'success' : 'secondary'}
                    onClick={(e) => setQrcode(e.currentTarget.value)}
                  >
                    {radio.name}
                  </Button>
                )
              }
            </Repeater>
          </ButtonGroup>
        </div>
      </div>
      <div>
        <p className="text-center"><FormattedMessage {...defaultMessages.armyListExportInformation} /></p>
        <div className="btn-group btn-group-full d-flex" role="group"
             aria-label="Button group with nested verbosity">
          <ButtonGroup className="mb-2">
            <Repeater data={formats} indexPrefix="format">
              {
                (radio: any) => (
                  <Button
                    value={radio.value}
                    color={radio.value === format ? 'success' : 'secondary'}
                    onClick={(e) => setFormat(e.currentTarget.value)}
                  >
                    {radio.name}
                  </Button>
                )
              }
            </Repeater>
          </ButtonGroup>
        </div>
      </div>

      <div className="text-center">
        <a href={exportHtml} target="_blank" className="btn btn-age btn-lg">
          <i className="fa fa-print" aria-hidden="true"/><FormattedMessage {...defaultMessages.armyListExportPrint} />
        </a>
      </div>
    </Col>
  </Row>
};

const mapStateToProps = (state: AppState) => ({
  armyListId: state.armyList.id
});

const mapDispatchToProps = (dispatch: Dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ArmyListFileExport);

type ArmyListFileExportProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
